import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import type { PsvNode } from '@indutrust/factory-model';
import { EnvironmentService } from '@indutrust/shared-env';
import { BaseApiClient } from '@indutrust/shared-model';

/**
 * API client for virtual-tour nodes (panorama scenes) nested under a
 * factory — `/factories/{factoryId}/vr_psv_nodes`.
 *
 * Call inherited CRUD methods with
 * `urlSegments: { factoryId: <id> }` to bind to a specific factory.
 */
@Service()
export class VrNodeApiClient extends BaseApiClient<PsvNode> {
  protected envService = inject(EnvironmentService);
  protected http = inject(HttpClient);

  protected template: Partial<PsvNode> = {};

  get url(): string {
    return `${this.envService.getApiUrl()}/factories/{factoryId}/vr_psv_nodes`;
  }
}
